import { createClient } from '@supabase/supabase-js'
import { getServiceRoleKey, publicEnv } from '@/lib/env'

export function createServiceRoleClient() {
  return createClient(publicEnv.supabaseUrl, getServiceRoleKey(), {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
    },
  })
}
